module.exports = __webpack_public_path__ + "public/images/rocket-head.ba829cbe334a65e70c0df1646d5b84fc.png";